import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'site-head',
  templateUrl: './site-head.component.html',
  styleUrls: ['./site-head.component.scss']
})
export class SiteHeadComponent implements OnInit {
  navToggled = false;

  constructor() { }

  ngOnInit() {
  }

  toggleNav () {
    if (this.navToggled) {
      this.navToggled = false;
    } else {
      this.navToggled = true;
    }
  }

  closeNav () {
    this.navToggled = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/site-head/site-head.component.ts